export default __webpack_public_path__ + "static/media/pic.454dbb1f.png";